import {createContext, JSXElement, onMount, useContext} from "solid-js";
import {posthog, PostHog} from "posthog-js"

const PostHogContext = createContext<PostHog>();

export default function PostHogProvider(props: { children: JSXElement }) {

    onMount(() => {
        // if (location.hostname === "localhost" || location.hostname === "127.0.0.1") return
        posthog.init('phc_m0d7zAIXvP1eGwUqCMAxuueQcHB1rrSSAchJsRwhJ7D',
            {
                api_host: 'https://eu.i.posthog.com',
                person_profiles: 'identified_only' // or 'always' to create profiles for anonymous users as well
            }
        )
    })

    return (
        <PostHogContext.Provider value={posthog}>
            {props.children}
        </PostHogContext.Provider>
    );
}

export function usePostHog() {
    const context = useContext(PostHogContext);
    if (!context) {
        throw new Error("usePostHog must be used within a PostHogProvider")
    }
    return context
}